import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

import path from "path";
import { pick } from "dot-object";
import { getter, setter } from "./utils";
import { traffic } from "./traffic";
import { lowercaseAndParseSpaces } from "../utils";
import icons from "./icons";

var parseTfaIDs = function parseTfaIDs(a) {
  if (a) {
    var b = a.split(",");
    return b;
  }

  return [];
};

window.get = getter;
var enquiryForm = traffic.get("enquiry_form"),
    api = traffic.get("api") || {};
export var config = _objectSpread({}, traffic, {
  //
  // Configure API
  //
  api: _objectSpread({}, api, {
    view_count: _objectSpread({
      key: "baf33e70--bfa83bd760d9",
      update_url: "https://interactive-lotusliving.appspot.com/api/traffic/update_pvc"
    }, api.view_count || {}),
    get: getter
  }),
  style: _objectSpread({}, traffic.get("style") || {}, {
    icons: _objectSpread({}, icons, {}, traffic.get("style.icons") || {}),
    get: getter
  }),
  //
  // Estate Icons and labels
  //
  estates: _objectSpread({}, traffic.get("estates") || {}, {
    get: getter
  }),
  //
  // Neighbourhoods Icons and labels
  //
  neighbourhoods: _objectSpread({}, traffic.get("neighbourhoods") || {}, {
    get: getter
  }),
  //
  // Routes
  //
  routes: _objectSpread({
    houseandland: "house-land-package",
    townhomes: "townhomes",
    apartments: "apartments"
  }, traffic.get("routes") || {}, {
    landforsale: _objectSpread({
      masterplan: "land-for-sale",
      results: "land-for-sale-search-results"
    }, traffic.get("routes.landforsale") || {}),
    property: _objectSpread({
      search: "property-search",
      results: "property-search-results"
    }, traffic.get("routes.property") || {}),
    get: function get(a) {
      var b = pick(a, this) || "";
      b && (b = "/".concat(b));

      for (var c = arguments.length, d = Array(1 < c ? c - 1 : 0), e = 1; e < c; e++) {
        d[e - 1] = arguments[e];
      }

      return b = path.join.apply(path, [b].concat(d)), "." === b ? "" : b;
    }
  }),
  //
  // Confire labels names
  //
  labels: _objectSpread({}, traffic.get("labels") || {}, {
    filters: _objectSpread({
      neighbourhood: "Neighbourhood",
      estate: "Estate"
    }, traffic.get("labels.filters") || {}),
    get: getter
  }),
  filters: _objectSpread({}, traffic.get("filters") || {}, {
    get: getter
  }),
  //
  // Advertising
  //
  promotions: traffic.get("promotions") || [],
  //
  // Enquiry Form
  //
  enquiryForm: "function" == typeof enquiryForm ? {
    type: "custom_function",
    function: enquiryForm,
    get: getter
  } : _objectSpread({
    privacy_policy: "",
    terms_and_conditions: ""
  }, enquiryForm || {}, {
    tfa_ids: parseTfaIDs(traffic.get("enquiry_form.tfa_ids")),
    get: getter
  }),
  //
  // Other Options
  //
  otherOptions: _objectSpread({}, traffic.get("other_options") || {}, {
    masterplan: _objectSpread({}, traffic.get("other_options.masterplan") || {}, {
      legend: traffic.get("other_options.masterplan.legend") || [{
        label: "Available"
      }, {
        label: "On hold"
      }, {
        label: "Builders"
      }, {
        label: "Sold"
      }]
    }),
    get: getter
  }),
  userCustomisationMenu: _objectSpread({}, traffic.get("user_customisation_menu") || {}, {
    enabled: !1,
    get: getter
  }),
  downloads: _objectSpread({}, traffic.get("downloads") || {}, {
    get: getter
  }),
  //
  // INMUTABLE CONFIGS
  //
  attributes: {
    1: "Corner Lot",
    2: "Standard Lot",
    3: "Irregular Lot",
    4: "Water Front",
    5: "Garden Front",
    6: "Golf Course",
    7: "Close to School",
    8: "Close to Child Care",
    9: "Close to Train Station",
    10: "Wetlands",
    11: "Park Front",
    12: "Swimming Pool",
    13: "Gym",
    14: "Passeggiata",
    15: "Extra Parking",
    16: "Dual Key",
    17: "Terrace",
    18: "Investment",
    19: "Balcony"
  },
  status: {
    1: "Available",
    2: "Sold",
    3: "Builders",
    4: "Hold",
    get: function get(a, b) {
      var c = (b || {}).slug,
          d = this[a];
      return c ? lowercaseAndParseSpaces(d, "-") : d;
    }
  },
  flags: function flags(a) {
    return a && a.custom ? a.custom : a && 1 === a.featured ? "featured" : a && 1 === a.titled ? "titled" : void 0;
  },
  propertyTypes: {
    house: "House and Land",
    townhome: "Townhome",
    apartment: "Apartment",
    land: "Land for Sale"
  },
  acf_settings: _objectSpread({}, traffic.get("acf_settings"), {
    get: getter
  }),
  set: setter
});
config.promotions && config.promotions.length && (config.promotions = config.promotions.map(function (a) {
  return a.get = getter, a;
})), window.location.hostname.includes("lotusliving.com.au") || ["jubilee", "silverwoods"].includes(config.api.get("project")) || ["urban-square"].includes(config.api.get("neighbourhood")) ? (config.userCustomisationMenu.enabled = !0, "jubilee" === config.api.get("project") && (config.userCustomisationMenu.height = "62px")) : config.userCustomisationMenu.enabled = !1, "jubilee" === config.api.get("project") && (config.neighbourhoods = _objectSpread({}, config.neighbourhoods || {}, {
  "the-mill-quarter": {
    label: "The Mill Quarter",
    logo: "".concat(process.env.PUBLIC_URL, "/img/neighbourhoods/the-mill-quarter.png"),
    color: "#e6cd21"
  },
  "scholars-green": {
    label: "Scholars Green",
    logo: "".concat(process.env.PUBLIC_URL, "/img/neighbourhoods/scholars-green.png"),
    color: "#5daa2c"
  },
  "urban-square": {
    label: "Urban Square",
    logo: "".concat(process.env.PUBLIC_URL, "/img/neighbourhoods/urban-square.png"),
    color: "#F37020"
  }
})), ["estates", "neighbourhoods"].map(function (a) {
  var b = Object.keys(config[a]);
  return b.length && b.map(function (b) {
    var c = config[a][b];
    return "object" == typeof c && ("jubilee" === b && (c.color = "#ba0c2f"), "silverwoods" === b && (c.color = "#000"), !c.logo && (c.logo = "".concat(process.env.PUBLIC_URL, "/img/estates/").concat(b, ".svg"))), null;
  }), null;
});
export default config;